import axiosInsAcademy from "@/api/axios-ugems-academy";

export default {
  // Get all training categories with filters and pagination
  getTrainingCategories(params) {
    return axiosInsAcademy.get("/training-categories", { params });
  },

  // Get single training category by ID
  getTrainingCategory(id) {
    return axiosInsAcademy.get(`/training-categories/${id}`);
  },

  // Create new training category
  createTrainingCategory(data) {
    return axiosInsAcademy.post("/training-categories", data);
  },

  // Update existing training category
  updateTrainingCategory(id, data) {
    return axiosInsAcademy.put(`/training-categories/${id}`, data);
  },

  // Delete training category
  deleteTrainingCategory(id) {
    return axiosInsAcademy.delete(`/training-categories/${id}`);
  }
};